import React, {PureComponent} from "react"
import {ApolloQueryResult} from "apollo-client"
import gql from "graphql-tag"
import {QueryProps} from "react-apollo"

import authentication from "@irati/auth"
import {Query} from "@irati/utils/services/apollo"

interface TenantWalletBalanceVariables {
  currency: string,
  tenantId: string
}

interface Props extends Partial<QueryProps> {
  children: any,
  useLoader?: boolean,
  variables?: TenantWalletBalanceVariables
}

interface Data {
  tenantWallet: Wallet
}

export type TenantWalletBalanceQueryResult = ApolloQueryResult<Data>

const query = gql`
  query TenantWallet($tenantId: String!, $currency: String!) {
    tenantWallet(tenantId: $tenantId, currency: $currency) {
      availableBalance
      currency
      ownerUuid
      uuid
    }
  }
`

export default class TenantWalletBalanceQueryComponent extends PureComponent<Props> {
  render() {
    const variables = {
      currency: authentication.defaultUserCurrency(),
      tenantId: authentication.userTenant().uuid
    }

    return <Query fetchPolicy="network-only" query={query} variables={variables} {...this.props} />
  }
}
